import React, { useState, useEffect, useRef, useContext } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import './confirmationModal.css';

const ConfirmationModalPlanner = ({
  visible,
  onHide,
  onConfirmRemove,
  idItem,
  children
}) => {

  const header = ( 
    <div>  
      {idItem &&  <Button
        label="Storno"
        icon="pi pi-sign-out"
        onClick={onConfirmRemove} 
        severity="danger" 
      />}   

    </div>
  );

  const formatDateSR = (isoString) => {
  if (!isoString) return '';

  const d = new Date(isoString);

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  return `${day}.${month}.${year}`;
};

const formatNumber = (value) => {
  if (value === null || value === undefined) return '-';
  return Number(value).toLocaleString('sr-RS', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

  return (
    <Dialog
      header={header}
      visible={visible}
      style={{ width: '80%' }}
      onHide={onHide}
      modal
      className="confirmation-modal"
    >
            {children}
    </Dialog>
  );
};

export default ConfirmationModalPlanner;